import { render, staticRenderFns } from "./projectDetail.vue?vue&type=template&id=1732724e&scoped=true"
import script from "./projectDetail.vue?vue&type=script&lang=js"
export * from "./projectDetail.vue?vue&type=script&lang=js"
import style0 from "../../../static/css/projectDetail.css?vue&type=style&index=0&id=1732724e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1732724e",
  null
  
)

export default component.exports